import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getdepartmentAPi, createdepartmentAPi,  uploaddepartmentAPi, deletedepartmentApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create department
export const createdepartment = createAsyncThunk('createdepartment/department', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createdepartmentAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatedepartment = createAsyncThunk('updatedepartment/department', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploaddepartmentAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get department
export const getdepartment = createAsyncThunk('getdepartment/department', async () => {
    try {
        const response = await axios.get(`${getdepartmentAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'departments' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete department
export const deletedepartments = createAsyncThunk('deletedepartments/department', async (departmentid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletedepartmentApi}/${departmentid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'departmentid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const DepartmentSlice = createSlice({
    name: 'department',
    initialState: {
        departments: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create department
            .addCase(createdepartment.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createdepartment.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createdepartment.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update department
            .addCase(updatedepartment.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatedepartment.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updatedepartment.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getdepartments
            .addCase(getdepartment.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getdepartment.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.departments = action.payload;
            })
            .addCase(getdepartment.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete departments
            .addCase(deletedepartments.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletedepartments.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.departments.data = state.departments.data.filter(departments => departments.departmentid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletedepartments.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default DepartmentSlice.reducer;
